import { Component, Inject } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { StatementOfAccountType } from '@models/statementOfAccount';
import { StatementOfAccountsDispatch } from '@state/matter/statementOfAccounts';
import { ICON } from '@core/util/icon';

export interface AddStatementOfAccountData {
	type: StatementOfAccountType;
	index: number;
	title: string;
}

@Component({
	selector: 'app-matter-statement-of-accounts-add',
	templateUrl: './add.component.html',
	standalone: false,
})
export class AddMatterStatementOfAccountComponent {
	public description: string;
	public price: number;
	public type: StatementOfAccountType;
	public index: number;
	public submitted = false;
	public ICON = ICON;
	public title = '';

	constructor(
		public dialogRef: MatDialogRef<AddMatterStatementOfAccountComponent>,
		@Inject(MAT_DIALOG_DATA) public data: AddStatementOfAccountData,
		private statementDispatch: StatementOfAccountsDispatch,
	) {
		this.type = data.type;
		this.index = data.index;
		this.title = data.title;
	}

	add(form: NgForm) {
		this.submitted = true;

		if (form.valid) {
			this.statementDispatch.Create(
				this.description,
				this.price,
				this.type,
				this.index,
				this.type === StatementOfAccountType.FEE,
			);
			this.dialogRef.close();
		}
	}
}
